"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.array.find");
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _personnelAuthorityManagement = require("@/api/authorityManagement/personnelAuthorityManagement");
var _creatApp = require("@/api/creatApp");
var _personnelManagement = require("@/api/authorityManagement/personnelManagement");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PersonnelAuthorityManagement',
  data: function data() {
    return {
      loading: false,
      queryData: {
        uid: null,
        nickName: null,
        phone: null,
        appId: null,
        page: {
          page: 1,
          size: 10
        }
      },
      tableData: [],
      total: 0,
      ControlsType: true,
      dialogVisible: false,
      ruleForm: {
        uid: null,
        nickName: '',
        phone: null,
        status: '',
        mappings: [
          // { appId: '', roleIds: [], options: [] }
        ]
      },
      rules: {
        nickName: [{
          required: true,
          message: '请输入用户昵称',
          trigger: 'blur'
        }, {
          min: 0,
          max: 99,
          message: '长度在 0 到 99 个字符',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          pattern: /^1[3-9]\d{9}$/,
          message: '请输入有效的手机号',
          trigger: ['blur', 'change']
        }],
        status: [{
          required: true,
          message: '请选择用户状态',
          trigger: 'change'
        }]
        // mappings: {
        //   type: 'array',
        //   required: true,
        //   message: '请至少添加一个角色映射',
        //   trigger: 'change',
        //   fields: {
        //     appId: [
        //       { required: true, message: '请选择应用ID', trigger: 'change' }
        //     ],
        //     roleIds: [
        //       { required: true, message: '请选择角色ID', trigger: 'change' }
        //     ]
        //   }
        // }
      },
      options: [],
      // app
      options1: [],
      // 角色
      appAndRolesData: []
    };
  },
  created: function created() {
    this.queryAppUserInAdminPage();
    this.getList();
    this.queryAppAndRoles();
  },
  methods: {
    getList: function () {
      var _getList2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _creatApp.getList)();
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.options = res.data;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getList() {
        return _getList2.apply(this, arguments);
      }
      return getList;
    }(),
    onInitQuery: function onInitQuery() {
      this.queryData = {
        uid: null,
        nickName: null,
        phone: null,
        appId: null,
        page: {
          page: 1,
          size: 10
        }
      };
    },
    onInquire: function onInquire() {
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.queryAppUserInAdminPage();
    },
    onInitialize: function onInitialize() {
      this.onInitQuery();
      this.queryAppUserInAdminPage();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.queryAppUserInAdminPage();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.queryAppUserInAdminPage();
    },
    // 列表查询
    queryAppUserInAdminPage: function () {
      var _queryAppUserInAdminPage2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.loading = true;
              _context2.p = 1;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context2.n = 2;
              return (0, _personnelAuthorityManagement.queryAppUserInAdminPage)(params);
            case 2:
              res = _context2.v;
              this.loading = false;
              if (res.code === 0) {
                this.tableData = res.data.data;
                this.total = res.data.total;
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              this.loading = false;
              console.log(_t2);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function queryAppUserInAdminPage() {
        return _queryAppUserInAdminPage2.apply(this, arguments);
      }
      return queryAppUserInAdminPage;
    }(),
    // 添加--------------------------------------------------------------------------
    // 弹窗
    onAdd: function onAdd() {
      this.ControlsType = true;
      this.dialogVisible = true;
    },
    onAddItem: function onAddItem() {
      this.ruleForm.mappings.push({
        appId: null,
        roleIds: null,
        options: []
      });
    },
    onDelMap: function onDelMap(index) {
      // this.ruleForm.mappings.splice(index, 1)
      if (index > -1 && index < this.ruleForm.mappings.length) {
        this.ruleForm.mappings.splice(index, 1);
      }
    },
    onClose: function onClose() {
      this.dialogVisible = false;
      this.onInitRuleForm();
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.$confirm('是否确认此操作?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this.adminAddOrUpdateAppUser();
          });
        } else {
          console.log('提交失败!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm = {
        uid: null,
        nickName: '',
        phone: null,
        status: '',
        mappings: []
      };
    },
    // 重置 ruleForm
    onInitRuleForm: function onInitRuleForm() {
      this.resetForm('ruleForm');
      this.ruleForm = {
        uid: null,
        nickName: '',
        phone: null,
        status: '',
        mappings: []
      };
    },
    // 添加接口
    adminAddOrUpdateAppUser: function () {
      var _adminAddOrUpdateAppUser2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.ruleForm), {}, {
                mappings: this.ruleForm.mappings.map(function (mapping) {
                  return {
                    appId: mapping.appId,
                    roleIds: mapping.roleIds
                  };
                })
              });
              _context3.n = 1;
              return (0, _personnelAuthorityManagement.adminAddOrUpdateAppUser)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.dialogVisible = false;
                this.onInitRuleForm();
                this.queryAppUserInAdminPage();
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function adminAddOrUpdateAppUser() {
        return _adminAddOrUpdateAppUser2.apply(this, arguments);
      }
      return adminAddOrUpdateAppUser;
    }(),
    // 过滤filterAppsByRoleId
    filterAppsByRoleId: function filterAppsByRoleId(apps, appId) {
      var filteredApp = apps.find(function (app) {
        return app.appId === appId;
      });
      return filteredApp ? filteredApp.roleInfos : null; // 如果找到，返回 roleInfos，否则返回 null
      // if (filteredApp) {
      //   // 过滤掉 roleCode 等于 'app_admin' 的项目
      //   const filteredRoleInfos = filteredApp.roleInfos.filter(role => role.roleCode !== 'app_admin')
      //   console.log('filteredRoleInfos', filteredRoleInfos)

      //   return filteredRoleInfos
      // }
    },
    onEditor: function onEditor(row) {
      var _this2 = this;
      console.log('row', row);
      this.ControlsType = false;
      this.ruleForm.uid = row.uid;
      this.ruleForm.nickName = row.nickName;
      this.ruleForm.phone = row.phone;
      this.ruleForm.status = row.status;
      var mappings = [];
      console.log('row.appRoleMappings', row.appRoleMappings);
      if (row.appRoleMappings && row.appRoleMappings.length > 0) {
        row.appRoleMappings.forEach(function (item) {
          var obj = {
            appId: item.appId,
            roleIds: null,
            options: _this2.filterAppsByRoleId(_this2.appAndRolesData, item.appId)
          };
          if (item.roleAbbreviations && item.roleAbbreviations.length > 0) {
            var roleIds = [];
            item.roleAbbreviations.forEach(function (i) {
              roleIds.push(i.roleId);
            });
            obj.roleIds = roleIds;
          }
          mappings.push(obj);
        });
      }
      this.ruleForm.mappings = mappings;
      this.dialogVisible = true;
    },
    // 获取app和其对应的角色
    queryAppAndRoles: function () {
      var _queryAppAndRoles2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var res, _t4;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return (0, _personnelAuthorityManagement.queryAppAndRoles)();
            case 1:
              res = _context4.v;
              if (res.code === 0) {
                this.appAndRolesData = res.data;
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              console.log(_t4);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function queryAppAndRoles() {
        return _queryAppAndRoles2.apply(this, arguments);
      }
      return queryAppAndRoles;
    }(),
    onAppChange: function () {
      var _onAppChange = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5(event, index) {
        var data, ids;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return this.queryAppManageRolesByAppId(event, index);
            case 1:
              data = _context5.v;
              this.ruleForm.mappings[index].options = data;
              if (this.ControlsType) {
                _context5.n = 3;
                break;
              }
              this.ruleForm.mappings[index].roleIds = [];
              _context5.n = 2;
              return this.queryAppManageRolesByAppIdAndUserId(this.ruleForm.uid, event);
            case 2:
              ids = _context5.v;
              this.ruleForm.mappings[index].roleIds = ids;
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function onAppChange(_x, _x2) {
        return _onAppChange.apply(this, arguments);
      }
      return onAppChange;
    }(),
    // 删除
    onDel: function onDel(row) {
      var _this3 = this;
      this.$confirm('是否确认删除该用户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.deleteUser(row.uid);
      });
    },
    deleteUser: function () {
      var _deleteUser2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6(uid) {
        var params, res, _t5;
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              params = {
                uid: uid
              };
              _context6.n = 1;
              return (0, _personnelManagement.deleteUser)(params);
            case 1:
              res = _context6.v;
              if (res.code === 0) {
                this.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.queryAppUserInAdminPage();
              }
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t5 = _context6.v;
              console.log(_t5);
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function deleteUser(_x3) {
        return _deleteUser2.apply(this, arguments);
      }
      return deleteUser;
    }(),
    queryAppManageRolesByAppId: function () {
      var _queryAppManageRolesByAppId2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee7(appId) {
        var params, res, _t6;
        return (0, _regenerator2.default)().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              params = {
                appId: appId
              };
              _context7.n = 1;
              return (0, _personnelAuthorityManagement.queryAppManageRolesByAppId)(params);
            case 1:
              res = _context7.v;
              if (!(res.code === 0)) {
                _context7.n = 2;
                break;
              }
              return _context7.a(2, res.data);
            case 2:
              _context7.n = 4;
              break;
            case 3:
              _context7.p = 3;
              _t6 = _context7.v;
              console.log(_t6);
            case 4:
              return _context7.a(2);
          }
        }, _callee7, null, [[0, 3]]);
      }));
      function queryAppManageRolesByAppId(_x4) {
        return _queryAppManageRolesByAppId2.apply(this, arguments);
      }
      return queryAppManageRolesByAppId;
    }(),
    queryAppManageRolesByAppIdAndUserId: function () {
      var _queryAppManageRolesByAppIdAndUserId2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee8(uid, appId) {
        var params, res, ids, _t7;
        return (0, _regenerator2.default)().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              _context8.p = 0;
              params = {
                uid: uid,
                appId: appId
              };
              _context8.n = 1;
              return (0, _personnelAuthorityManagement.queryAppManageRolesByAppIdAndUserId)(params);
            case 1:
              res = _context8.v;
              if (!(res.code === 0)) {
                _context8.n = 2;
                break;
              }
              ids = res.data.map(function (item) {
                return item.id;
              });
              return _context8.a(2, ids);
            case 2:
              _context8.n = 4;
              break;
            case 3:
              _context8.p = 3;
              _t7 = _context8.v;
              console.log(_t7);
            case 4:
              return _context8.a(2);
          }
        }, _callee8, null, [[0, 3]]);
      }));
      function queryAppManageRolesByAppIdAndUserId(_x5, _x6) {
        return _queryAppManageRolesByAppIdAndUserId2.apply(this, arguments);
      }
      return queryAppManageRolesByAppIdAndUserId;
    }()
  }
};